import "@nike/eds/dist/index.css";
import {InventoryService} from "./components/shared/InventoryService";
import React, {useContext} from "react";
import SnackbarContext from "./providers/snackbar-context";
import {Route, Routes} from "react-router-dom";
import ApplicationSnackbar from "./components/shared/ApplicationSnackbar";
import {InventoryOverview} from "./components/overview/InventoryOverview";
import {InventoryItemDetail} from "./components/detail/InventoryItemDetail";
import InventoryServiceContext from "./providers/inventoryService-context";
import {EntryContextOverview} from "./components/entry-context/EntryContextOverview";
import {Dashboard} from "./components/dashboard/Dashboard";
import {DownloadableReports} from "./components/download/DownloadableReports";
import { 
  ChatWidgetProvider, 
  ChatWidget 
} from '@nike/ai-chat-widget/react';
import {oktaAuth} from "./components/config/OktaConfig";

const chatApiEndpoint = process.env.REACT_APP_CHAT_WIDGET || "";

const inventoryService: InventoryService = new InventoryService()

export function App({locationTracker, host, permissions}) {
    const snackbarCtx = useContext(SnackbarContext);

    return (
        <ChatWidgetProvider
                  apiEndpoint={chatApiEndpoint}
                  agent="sme-agent-aws"
                  mode="floating"
                  initialOktaToken={oktaAuth.getAccessToken()}>
            <InventoryServiceContext.Provider value={inventoryService}>
                <div>
                    <Routes>
                        <Route path="/dashboard"
                            element={<Dashboard inventoryService={inventoryService}/>}/>
                        <Route path="/inventory-overview"
                            element={<InventoryOverview inventoryService={inventoryService} LocationTracker={locationTracker} />}/>
                        <Route path="/inventory-overview/details/:materialNumber/:size/:countryOfOrigin/:quality"
                            element={<InventoryItemDetail inventoryService={inventoryService} LocationTracker={locationTracker} host={host} permissions={permissions} />}/>
                        <Route path="/entry-context-overview"
                            element={<EntryContextOverview inventoryService={inventoryService} LocationTracker={locationTracker} />}/>
                        <Route path="/inventory-overview/downloadable-reports"
                            element={<DownloadableReports inventoryService={inventoryService}/>}/>
                    </Routes>
                    {snackbarCtx.isDisplayed && <ApplicationSnackbar/>}
                </div>
            </InventoryServiceContext.Provider>

            { chatApiEndpoint && <ChatWidget /> }
        </ChatWidgetProvider>
    );
}

export default App;
